/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TransportAutoTruckIcon16Light } from './TransportAutoTruckIcon16Light';
import { TransportAutoTruckIcon16Regular } from './TransportAutoTruckIcon16Regular';
import { TransportAutoTruckIcon16Solid } from './TransportAutoTruckIcon16Solid';
import { TransportAutoTruckIcon20Light } from './TransportAutoTruckIcon20Light';
import { TransportAutoTruckIcon20Regular } from './TransportAutoTruckIcon20Regular';
import { TransportAutoTruckIcon20Solid } from './TransportAutoTruckIcon20Solid';
import { TransportAutoTruckIcon24Regular } from './TransportAutoTruckIcon24Regular';
import { TransportAutoTruckIcon24Solid } from './TransportAutoTruckIcon24Solid';
import { TransportAutoTruckIcon32Regular } from './TransportAutoTruckIcon32Regular';
import { TransportAutoTruckIcon64Regular } from './TransportAutoTruckIcon64Regular';
var sizes = {
    16: {
        light: TransportAutoTruckIcon16Light,
        regular: TransportAutoTruckIcon16Regular,
        solid: TransportAutoTruckIcon16Solid,
    },
    20: {
        light: TransportAutoTruckIcon20Light,
        regular: TransportAutoTruckIcon20Regular,
        solid: TransportAutoTruckIcon20Solid,
    },
    24: {
        regular: TransportAutoTruckIcon24Regular,
        solid: TransportAutoTruckIcon24Solid,
    },
    32: {
        regular: TransportAutoTruckIcon32Regular,
    },
    64: {
        regular: TransportAutoTruckIcon64Regular,
    },
};
export var TransportAutoTruckIcon = forwardRef('TransportAutoTruckIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
